import { render, staticRenderFns } from "./button-loading.vue?vue&type=template&id=559f7e3c"
import script from "./button-loading.vue?vue&type=script&lang=ts"
export * from "./button-loading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports